import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowInTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowInTopLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M4.00015 2.58594L9.00015 7.58594V3.00015H11.0002V11.0001L3.00015 11.0002L3.00015 9.00015L7.58594 9.00015L2.58594 4.00015L4.00015 2.58594ZM13.0002 6.00015H22.0002V22.0002H6.00015V13.0002H8.00015V20.0002H20.0002V8.00015H13.0002V6.00015Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowInTopLeft;
